var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('my-header',{ref:"header"}),_c('div',{staticClass:"container"},[_c('nav-menu',{class:_vm.fixed ? 'fixed' : ''}),_c('router-view',{staticClass:"router-view-wrap"})],1),_c('base-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }